// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"

const modelClassData = {
  "attributes": {
    "address": {
      "column": {
        "default": false,
        "name": "address",
        "null": false,
        "type": "boolean"
      },
      "name": "address",
      "selected_by_default": null,
      "translated": null
    },
    "birthday": {
      "column": {
        "default": false,
        "name": "birthday",
        "null": false,
        "type": "boolean"
      },
      "name": "birthday",
      "selected_by_default": null,
      "translated": null
    },
    "class_step": {
      "column": {
        "default": false,
        "name": "class_step",
        "null": false,
        "type": "boolean"
      },
      "name": "class_step",
      "selected_by_default": null,
      "translated": null
    },
    "consent": {
      "column": {
        "default": false,
        "name": "consent",
        "null": false,
        "type": "boolean"
      },
      "name": "consent",
      "selected_by_default": null,
      "translated": null
    },
    "email": {
      "column": {
        "default": false,
        "name": "email",
        "null": false,
        "type": "boolean"
      },
      "name": "email",
      "selected_by_default": null,
      "translated": null
    },
    "first_name": {
      "column": {
        "default": false,
        "name": "first_name",
        "null": false,
        "type": "boolean"
      },
      "name": "first_name",
      "selected_by_default": null,
      "translated": null
    },
    "gender": {
      "column": {
        "default": false,
        "name": "gender",
        "null": false,
        "type": "boolean"
      },
      "name": "gender",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "last_name": {
      "column": {
        "default": false,
        "name": "last_name",
        "null": false,
        "type": "boolean"
      },
      "name": "last_name",
      "selected_by_default": null,
      "translated": null
    },
    "phone_number": {
      "column": {
        "default": false,
        "name": "phone_number",
        "null": false,
        "type": "boolean"
      },
      "name": "phone_number",
      "selected_by_default": null,
      "translated": null
    },
    "relative_info": {
      "column": {
        "default": false,
        "name": "relative_info",
        "null": false,
        "type": "boolean"
      },
      "name": "relative_info",
      "selected_by_default": null,
      "translated": null
    },
    "school": {
      "column": {
        "default": false,
        "name": "school",
        "null": false,
        "type": "boolean"
      },
      "name": "school",
      "selected_by_default": null,
      "translated": null
    },
    "school_class": {
      "column": {
        "default": false,
        "name": "school_class",
        "null": true,
        "type": "boolean"
      },
      "name": "school_class",
      "selected_by_default": null,
      "translated": null
    },
    "show_only_required_fields": {
      "column": {
        "default": false,
        "name": "show_only_required_fields",
        "null": false,
        "type": "boolean"
      },
      "name": "show_only_required_fields",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "RequiredMetadatum",
  "collectionKey": "required_metadata",
  "collectionName": "required_metadata",
  "i18nKey": "required_metadatum",
  "camelizedLower": "requiredMetadatum",
  "name": "RequiredMetadatum",
  "nameDasherized": "required-metadatum",
  "pluralName": "required_metadata",
  "ransackable_associations": [
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Resource",
      "collectionName": null,
      "foreignKey": "resource_id",
      "name": "resource",
      "macro": "belongs_to",
      "resource_name": null,
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "address",
      "column": {
        "default": false,
        "name": "address",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "birthday",
      "column": {
        "default": false,
        "name": "birthday",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "class_step",
      "column": {
        "default": false,
        "name": "class_step",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "consent",
      "column": {
        "default": false,
        "name": "consent",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "email",
      "column": {
        "default": false,
        "name": "email",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "first_name",
      "column": {
        "default": false,
        "name": "first_name",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "gender",
      "column": {
        "default": false,
        "name": "gender",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "last_name",
      "column": {
        "default": false,
        "name": "last_name",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_resource_id",
      "column": {
        "default": null,
        "name": "old_resource_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "phone_number",
      "column": {
        "default": false,
        "name": "phone_number",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "relative_info",
      "column": {
        "default": false,
        "name": "relative_info",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "resource_id",
      "column": {
        "default": null,
        "name": "resource_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "resource_type",
      "column": {
        "default": null,
        "name": "resource_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "school",
      "column": {
        "default": false,
        "name": "school",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "school_class",
      "column": {
        "default": false,
        "name": "school_class",
        "null": true,
        "type": "boolean"
      }
    },
    {
      "name": "show_only_required_fields",
      "column": {
        "default": false,
        "name": "show_only_required_fields",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [],
  "paramKey": "required_metadatum",
  "primaryKey": "id"
}

/** Frontend model for RequiredMetadatum. */
export default class RequiredMetadatum extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {boolean} */
  address() {
    return this.readAttributeUnderscore("address")
  }

  /** @returns {boolean} */
  hasAddress() {
    const value = this.address()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  birthday() {
    return this.readAttributeUnderscore("birthday")
  }

  /** @returns {boolean} */
  hasBirthday() {
    const value = this.birthday()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  classStep() {
    return this.readAttributeUnderscore("class_step")
  }

  /** @returns {boolean} */
  hasClassStep() {
    const value = this.classStep()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  consent() {
    return this.readAttributeUnderscore("consent")
  }

  /** @returns {boolean} */
  hasConsent() {
    const value = this.consent()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  email() {
    return this.readAttributeUnderscore("email")
  }

  /** @returns {boolean} */
  hasEmail() {
    const value = this.email()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  firstName() {
    return this.readAttributeUnderscore("first_name")
  }

  /** @returns {boolean} */
  hasFirstName() {
    const value = this.firstName()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  gender() {
    return this.readAttributeUnderscore("gender")
  }

  /** @returns {boolean} */
  hasGender() {
    const value = this.gender()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  lastName() {
    return this.readAttributeUnderscore("last_name")
  }

  /** @returns {boolean} */
  hasLastName() {
    const value = this.lastName()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  phoneNumber() {
    return this.readAttributeUnderscore("phone_number")
  }

  /** @returns {boolean} */
  hasPhoneNumber() {
    const value = this.phoneNumber()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  relativeInfo() {
    return this.readAttributeUnderscore("relative_info")
  }

  /** @returns {boolean} */
  hasRelativeInfo() {
    const value = this.relativeInfo()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  school() {
    return this.readAttributeUnderscore("school")
  }

  /** @returns {boolean} */
  hasSchool() {
    const value = this.school()

    return this._isPresent(value)
  }

  /** @returns {boolean | null} */
  schoolClass() {
    return this.readAttributeUnderscore("school_class")
  }

  /** @returns {boolean} */
  hasSchoolClass() {
    const value = this.schoolClass()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  showOnlyRequiredFields() {
    return this.readAttributeUnderscore("show_only_required_fields")
  }

  /** @returns {boolean} */
  hasShowOnlyRequiredFields() {
    const value = this.showOnlyRequiredFields()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  updateUser(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "update_user",
        primaryKey: this.primaryKey(),
        collectionName: "required_metadata",
        type: "member"
      },
      commandArgs
    ))
  }
}
